import styled from 'styled-components'
import { TransparentButton as TB } from 'common/button'
import { useSocialMedia } from 'querys/profile'
import { MdClose } from 'react-icons/md'
import Github from 'common/github-button'
import Discord from 'common/discord-button'
import { Typography } from 'common/typography'
import AsideMenu from './aside-menu'
import PlanProjectRevision from './plan-project-revision'
import ProjectStatus from './project-status'

const RevisionContainerStyled = styled.div`
  .aside-title {
    display: flex;
    justify-content: space-between;
    margin-block-end: 1rem;
  }
  .unlink-banner {
    padding: 16px 0;
    background: #FFDD66;
    color: var(--black);
  }
  .social-media-vinculation {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    .vinculation-copy {
      margin: 0;
    }
    a {
      align-self: initial;
    }
  }
  @media(min-width: 768px) {
    .social-media-vinculation {
      /* display: block; */
    }
  }
`

function RevisionContainer({ open, setOpen, project, progress_status, refetch, requirements }) {
  const { data } = useSocialMedia()

  if (progress_status?.status === 'COMPLETED' || progress_status?.status === 'IN REVIEW') {
    return (
      <AsideMenu show={open}>
        <ProjectStatus {...progress_status} setOpen={setOpen} username={data.github_username} />
      </AsideMenu>
    )
  }

  return (
    <AsideMenu show={open}>
      <RevisionContainerStyled>
        {!data.github_username || !data.github_token || !data.discord_username ? (
          <>
            <div className="aside-title">
              <Typography font="headline6">
                Vincula tu redes
              </Typography>
              <TB onClick={() => setOpen(false)}>
                <MdClose size={24} />
              </TB>
            </div>
            <p>
              Para solicitar la revisión de un proyecto
              <b> es necesario vincular tu cuenta de GitHub y Discord.</b>
            </p>
            {!data.github_username || data.github_token ? (
              <Github />
            ) : null}
            {!data.discord_username ? (
              <Discord />
            ) : null}
          </>
        ) : (
          <PlanProjectRevision
            project={project}
            // open={open}
            setOpen={setOpen}
            refetch={refetch}
            requirements={requirements}
          />
        )}
      </RevisionContainerStyled>
    </AsideMenu>
  )
}

export default RevisionContainer
